// Text hashing via the Web Crypto API (SubtleCrypto). One component + config
// powers the SHA hash generator cluster. Hashing runs locally in the browser.

export type HashVariant =
  | 'sha1-generator'
  | 'sha256-generator'
  | 'sha384-generator'
  | 'sha512-generator';

const algorithmByVariant: Record<HashVariant, string> = {
  'sha1-generator': 'SHA-1',
  'sha256-generator': 'SHA-256',
  'sha384-generator': 'SHA-384',
  'sha512-generator': 'SHA-512',
};

export const hashLabelByVariant: Record<HashVariant, string> = {
  'sha1-generator': 'SHA-1',
  'sha256-generator': 'SHA-256',
  'sha384-generator': 'SHA-384',
  'sha512-generator': 'SHA-512',
};

export async function computeHash(variant: HashVariant, text: string): Promise<string> {
  const bytes = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest(algorithmByVariant[variant], bytes);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}
